import React, { Component } from 'react';
import { List } from 'semantic-ui-react';

class SocialLinks extends Component {
  render() {
    const club = this.props.club;
    return (
      <List horizontal floated="right" className="hidden">
        {club.facebook ? (
          <List.Item className="club-contact-item">
            <a target="_blank" href={club.facebook}>
              <List.Icon name="facebook f" size="large" />
            </a>
          </List.Item>
        ) : (
          ''
        )}
        {club.instagram ? (
          <List.Item className="club-contact-item">
            <a target="_blank" href={club.instagram}>
              <List.Icon name="instagram" size="large" />
            </a>
          </List.Item>
        ) : (
          ''
        )}
        {club.twitter ? (
          <List.Item className="club-contact-item">
            <a target="_blank" href={club.twitter}>
              <List.Icon name="twitter" size="large" color="twitter" />
            </a>
          </List.Item>
        ) : (
          ''
        )}
        {club.email ? (
          <List.Item className="club-contact-item">
            <a href={`mailto:${club.email}`}>
              <List.Icon name="mail" size="large" />
            </a>
          </List.Item>
        ) : (
          ''
        )}
        {club.website ? (
          <List.Item className="club-contact-item">
            <a target="_blank" href={club.website}>
              <List.Icon name="globe" size="large" />
            </a>
          </List.Item>
        ) : (
          ''
        )}
      </List>
    );
  }
}

export default SocialLinks;



// WEBPACK FOOTER //
// ./src/components/Club/SocialLinks.js